<div class="branding-container">
  <app-header-actions [headerTitle]="'BRANDING.TITLE' | translate" [headerIcon]="faPalette" [config]="headerConfig"
    [initialFilters]="{ searchTerm: searchTerm, selectedTag: '' }"
    [count]="filteredTenants.length + ' ' + ('BRANDING.TITLE_PLURAL' | translate)" [showCount]="true"
    (addClick)="openCreateModal()" (backClick)="goBack()"
    (filtersChanged)="onHeaderFiltersChanged($event)"></app-header-actions>

  <div class="content-area">
    <app-item-list [items]="itemsForList" [loading]="loading" [config]="listConfig"
      [hasActiveFilters]="hasActiveFilters" (itemClick)="onItemClick($event)" (actionClick)="onActionClick($event)">
    </app-item-list>
  </div>

  @if (showCreateModal || showEditModal) {
  <app-modal-create-edit-tenant [show]="showCreateModal || showEditModal" [isEdit]="showEditModal"
    [tenant]="selectedTenant" (close)="closeModals()" (updated)="onTenantUpdated()">
  </app-modal-create-edit-tenant>
  }

  @if (showDeleteModal) {
  <app-modal-delete-confirm [show]="showDeleteModal" [configKey]="selectedTenant?.name || ''" configType="tenant"
    (close)="closeModals()" (confirm)="deleteTenant()">
  </app-modal-delete-confirm>
  }
</div>
